import { render, staticRenderFns } from "./GlobalDashLayout.vue?vue&type=template&id=c1731426&scoped=true"
import script from "./GlobalDashLayout.vue?vue&type=script&lang=js"
export * from "./GlobalDashLayout.vue?vue&type=script&lang=js"
import style0 from "./GlobalDashLayout.vue?vue&type=style&index=0&id=c1731426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1731426",
  null
  
)

export default component.exports